export default "__VITE_ASSET__GDutm62F__"